<template>
    <v-app-bar app clipped-left clipped-right color="white" light>
        <v-toolbar-title class="align-center d-flex">
      <span class="logo-icon">
        <!--suppress HtmlRequiredAltAttribute -->
          <img src="../../assets/images/logo.svg"/>
      </span>
        </v-toolbar-title>
        <!--    <v-app-bar-nav-icon
              class="d-block d-md-none"
              @click="$vuetify.breakpoint.smAndDown ? setSidebarDrawer(!Sidebar_drawer) : $emit('input', !value)"
            />-->
        <!--    <v-spacer />-->
        <!---right part -->
        <!-- <v-menu bottom left transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn dark icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-for="(item, i) in userprofile" :key="i" @click="href">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->

        <v-toolbar-items>
            <v-btn text
                   v-for="item in itemsWithPermissions"
                   :key="item.title"
                   :to="item.to"
                   :active-class="`success white--text`"
                   link
            >
                <v-icon left>{{ item.icon }}</v-icon>
                {{ item.title }}
            </v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <div class="user">
            <span class="username">{{ user.name || user.email }}</span>
<!--        <v-btn icon @click="onClickLogout">-->
                <v-icon-tooltip icon="mdi-logout" left @click="onClickLogout">Выйти</v-icon-tooltip>
<!--        </v-btn>-->
        </div>
    </v-app-bar>
</template>
<script>
// Utilities
import {mapState, mapMutations} from "vuex";
import UserAuth from "@/mixins/UserAuth";
import HasPermissionsToRoute from "@/mixins/HasPermissionsToRoute";
import _ from "lodash";
import VIconTooltip from "@/components/commonComponents/VIconTooltip.vue";

export default {
    name: "Header",

    components: {VIconTooltip},
    mixins: [
        UserAuth,
        HasPermissionsToRoute,
    ],

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        href() {
            return undefined;
        },
        items: [

            {
                title: "Мероприятия",
                icon: "mdi-calendar",
                to: {name: "Forums"},
            },

            {
                title: "Пользователи",
                icon: "mdi-account-multiple",
                to: {name: "Users"},
            },

            // @TODO: удалить демо-компоненты
            /*
            {
                title: "Компоненты",
                icon: "mdi-view-dashboard",
                to: "/dashboard/components-demo"
            },
             */

            /* {
              title: "Profile",
              icon: "mdi-account-circle",
              to: "/pages/profile"
            }, */
        ]

    }),

    computed: {
        ...mapState(["Sidebar_drawer"]),
        itemsWithPermissions() {
            return _.filter(this.items, item => this.hasPermissionsToRoute(item.to));
        }
    },

    methods: {
        ...mapMutations({
            setSidebarDrawer: "SET_SIDEBAR_DRAWER"
        }),
        onClickLogout() {
            this.$api.get(this.$apiUrl.getUserLogoutUrl())
                .finally(() => {
                    this.isAuthorized = false;
                });
        },
    }
};
</script>
<style lang="scss" scoped>
.logo-icon {
    width: 220px;
}
.v-toolbar__title {
    margin-right: 110px;
    // justify-content: center;
    line-height: 0;
}
.user {
    margin-left: 15px;
    .username {
        padding-right: 10px;
        color: rgba(0, 0, 0, 0.6);
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 21px;
    }
}
</style>